var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tabArrivalInformation" } }, [
    _c(
      "div",
      { staticStyle: { width: "fit-content" } },
      [
        _c(
          "tab-arrival-information-UICustom-layout",
          {
            attrs: {
              "element-blocks": _vm.elementBlocks,
              disabled: _vm.readonly
            }
          },
          [
            _vm.elementDict.estimatedArrivalTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedArrivalTime" },
                    slot: "estimatedArrivalTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedArrivalTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.estimatedArrivalTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "1",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedArrivalTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                        },
                        expression: "form.estimatedArrivalTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.actualArrivalTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "actualArrivalTime" },
                    slot: "actualArrivalTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.actualArrivalTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.actualArrivalTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "2",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualArrivalTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "actualArrivalTime", $$v)
                        },
                        expression: "form.actualArrivalTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedPortDischargeTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedPortDischargeTime" },
                    slot: "estimatedPortDischargeTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedPortDischargeTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.estimatedPortDischargeTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "3",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedPortDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedPortDischargeTime", $$v)
                        },
                        expression: "form.estimatedPortDischargeTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.portDischargeTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "portDischargeTime" },
                    slot: "portDischargeTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.portDischargeTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.portDischargeTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "4",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.portDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "portDischargeTime", $$v)
                        },
                        expression: "form.portDischargeTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedRailwayDepartureTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedRailwayDepartureTime" },
                    slot: "estimatedRailwayDepartureTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedRailwayDepartureTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.estimatedRailwayDepartureTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "estimatedRailwayDepartureTime",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedRailwayDepartureTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedRailwayDepartureTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedRailwayDepartureTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.railwayDepartureTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "railwayDepartureTime" },
                    slot: "railwayDepartureTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.railwayDepartureTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.railwayDepartureTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "5",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.railwayDepartureTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "railwayDepartureTime", $$v)
                        },
                        expression: "form.railwayDepartureTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedRailwayDischargeTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedRailwayDischargeTime" },
                    slot: "estimatedRailwayDischargeTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedRailwayDischargeTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.estimatedRailwayDischargeTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "6",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedRailwayDischargeTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedRailwayDischargeTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedRailwayDischargeTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.railwayDischargeTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "railwayDischargeTime" },
                    slot: "railwayDischargeTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.railwayDischargeTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.railwayDischargeTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "7",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.railwayDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "railwayDischargeTime", $$v)
                        },
                        expression: "form.railwayDischargeTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedArrivalPlaceOfDelivery.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedArrivalPlaceOfDelivery" },
                    slot: "estimatedArrivalPlaceOfDelivery"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedArrivalPlaceOfDelivery
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.estimatedArrivalPlaceOfDelivery.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "8",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedArrivalPlaceOfDelivery,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedArrivalPlaceOfDelivery",
                            $$v
                          )
                        },
                        expression: "form.estimatedArrivalPlaceOfDelivery"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.actualArrivalPlaceOfDelivery.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "actualArrivalPlaceOfDelivery" },
                    slot: "actualArrivalPlaceOfDelivery"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.actualArrivalPlaceOfDelivery
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.actualArrivalPlaceOfDelivery.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "9",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualArrivalPlaceOfDelivery,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "actualArrivalPlaceOfDelivery",
                            $$v
                          )
                        },
                        expression: "form.actualArrivalPlaceOfDelivery"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedCustomsReleaseTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedCustomsReleaseTime" },
                    slot: "estimatedCustomsReleaseTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedCustomsReleaseTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.estimatedCustomsReleaseTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "10",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedCustomsReleaseTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedCustomsReleaseTime", $$v)
                        },
                        expression: "form.estimatedCustomsReleaseTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destPortCustomsClearanceTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "destPortCustomsClearanceTime" },
                    slot: "destPortCustomsClearanceTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destPortCustomsClearanceTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.destPortCustomsClearanceTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "11",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortCustomsClearanceTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "destPortCustomsClearanceTime",
                            $$v
                          )
                        },
                        expression: "form.destPortCustomsClearanceTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedPickUpTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "estimatedPickUpTime",
                      title: _vm.elementDict.estimatedPickUpTime.label
                    },
                    slot: "estimatedPickUpTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedPickUpTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.estimatedPickUpTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "12",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedPickUpTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedPickUpTime", $$v)
                        },
                        expression: "form.estimatedPickUpTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.actualPickUpTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "actualPickUpTime",
                      title: _vm.elementDict.actualPickUpTime.label
                    },
                    slot: "actualPickUpTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.actualPickUpTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.actualPickUpTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "13",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualPickUpTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "actualPickUpTime", $$v)
                        },
                        expression: "form.actualPickUpTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedDeliveryToWarehouseTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "estimatedDeliveryToWarehouseTime",
                      title:
                        _vm.elementDict.estimatedDeliveryToWarehouseTime.label
                    },
                    slot: "estimatedDeliveryToWarehouseTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedDeliveryToWarehouseTime
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.estimatedDeliveryToWarehouseTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "14",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedDeliveryToWarehouseTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedDeliveryToWarehouseTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedDeliveryToWarehouseTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.deliveryTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "deliveryTime",
                      title: _vm.elementDict.deliveryTime.label
                    },
                    slot: "deliveryTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.deliveryTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.deliveryTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "15",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.deliveryTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "deliveryTime", $$v)
                        },
                        expression: "form.deliveryTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destPortDeliveryTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "destPortDeliveryTime",
                      title: _vm.elementDict.destPortDeliveryTime.label
                    },
                    slot: "destPortDeliveryTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destPortDeliveryTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.destPortDeliveryTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "16",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortDeliveryTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destPortDeliveryTime", $$v)
                        },
                        expression: "form.destPortDeliveryTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.deliveryCompletionDate.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      slot: "deliveryCompletionDate",
                      title: _vm.elementDict.deliveryCompletionDate.label
                    },
                    slot: "deliveryCompletionDate"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.deliveryCompletionDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.deliveryCompletionDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "17",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.deliveryCompletionDate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "deliveryCompletionDate", $$v)
                        },
                        expression: "form.deliveryCompletionDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.estimatedReturnTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "estimatedReturnTime" },
                    slot: "estimatedReturnTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.estimatedReturnTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.estimatedReturnTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "20",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedReturnTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedReturnTime", $$v)
                        },
                        expression: "form.estimatedReturnTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destPortReturnTime.visible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "destPortReturnTime" },
                    slot: "destPortReturnTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destPortReturnTime.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.destPortReturnTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "21",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortReturnTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destPortReturnTime", $$v)
                        },
                        expression: "form.destPortReturnTime"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }